export default __webpack_public_path__ + "static/media/steps-walk.a3d82038.svg";